import { useContext, useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaTable } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";

import { useIconSrc } from "@/hooks/use-icon-src";
import { useProjectListQuery } from "@/queries/query-project";
import { nameColumnString } from "@/translations";
import { getSort } from "@/utils/get-sort";

export function TenantMyProjectList() {
  const intl = useIntl();
  const icon = useIconSrc("project");
  const projectsResponse = useProjectListQuery();
  const { user, tenant } = useContext(TenantContext);

  const myProjects = useMemo(() => {
    const allProjects = projectsResponse?.data?.items ?? [];
    const filteredProjects = !("id" in user)
      ? allProjects
      : allProjects.filter(({ contributors }) => contributors.some(({ id }) => id === user.id));

    // Sort by lastActivity in descending order (most recent first)
    return [...filteredProjects].sort((a, b) => getSort(a.lastActivity, b.lastActivity, "za"));
  }, [projectsResponse, user]);

  return (
    <RanaTable
      columnDefinitions={[
        {
          width: "auto",
          title: nameColumnString(intl),
          orderingField: "name",
        },
      ]}
      isSkeleton={projectsResponse.isLoading}
      tableDataIds={myProjects.map((project) => project.id)}
      emptyElement={
        <RanaTable.Empty icon={icon}>
          <FormattedMessage
            id="table.empty.no_projects_contributor"
            defaultMessage="You have not contributed to any projects yet."
          />
        </RanaTable.Empty>
      }
    >
      <RanaTable.Container borderWidth={0} minH="full">
        <RanaTable.Body>
          {myProjects.map((project) => (
            <RanaTable.Row
              to={`/${tenant}/projects/${project.slug}`}
              key={project.id}
              rowId={project.id}
            >
              <RanaTable.Cell>{project.name}</RanaTable.Cell>
            </RanaTable.Row>
          ))}
        </RanaTable.Body>
      </RanaTable.Container>
    </RanaTable>
  );
}
